import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const Login = ({ location, authenticate }) => {
  const { state } = location
  const referrer = state ? state.referrer : undefined
  return <div>
    <h1>
      I'm unprotected
    </h1>
    <button onClick={() => authenticate()} >Toggle Authentication</button>
    <Link to='/protected'>
      <h2>Protected</h2>
    </Link>
    {referrer ? <Link to={referrer}><h2>Go to {referrer}</h2></Link> : undefined}
  </div>
}

Login.propTypes = {
  location: PropTypes.object.isRequired,
  authenticate: PropTypes.func.isRequired
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login.js